import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getEntitiesTaggables : function({ commit }, data){

		return new Promise((resolve, reject) => {
			var params = {
				filters : data.filters
			}

			api.get('admin/tag-configs', params).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	},

	getEntityTaggable : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.get('admin/tag-configs/'+data.id, {}).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	createEntityTaggableGroup : function({ commit }, data){
	
		return new Promise((resolve, reject) => {
			api.post('admin/tag-configs/'+data.id+'/add-group', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},

	addFieldToGroup : function({ commit }, data){
	
		return new Promise((resolve, reject) => {
			api.post('admin/tag-configs/'+data.id+'/groups/'+data.group_id+'/add-field', data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},
	deleteEntityTaggableGroup : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.delete('admin/tag-configs/'+data.id+'/groups/'+data.group_id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	},
	deleteEntityTaggableField : function({ commit }, data){
		return new Promise((resolve, reject) => {
			api.delete('admin/tag-configs/'+data.id+'/groups/'+data.group_id+'/fields/'+data.field_id, data).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			})
		});
	}
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/EntityTaggableModule.js